<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-5' : 'justify-space-between'"
      class="d-flex"
    >
      <v-card-title
        class="align-self-start titre-h3 mt-3 mb-3 ml-1"
      >
        Mes cultures
        <AgrButton
          class="margin-top"
          icon
          @click="isOpenModalHelp = true"
        >
          <v-icon color="primary">
            mdi-information
          </v-icon>
        </AgrButton>
      </v-card-title>
      <AdherentRebond
        v-if="redirection"
        :class="$vuetify.breakpoint.mobile ? '' :'position'"
        :path-origine="pagePath"
        :redirection="redirection"
      />
    </div>
    <BaseMessageServerError v-if="serverError" />
    <div>
      <!-- Toutes mes graines -->
      <BaseLoader v-if="loading.cultures" />
      <ResumeCultures
        v-if="!loading.cultures && !serverError"
        :annee-recolte="anneeSelected"
        :recoltes="listeAnnees"
        :resume-recolte="resumeRecolte"
        class="mt-3"
        @selectAnneeRecolte="selectRecolte"
      />
      <BaseMessage
        v-if="!loading.cultures && !serverError && hasClotureEnCours"
        class="mt-3"
        color="var(--orange-dark)"
        message="Un coût de production est en cours sur cette année de récolte. L'ajout, la modification ou la suppression d'une culture aura un impact sur la saisie du coût de production."
        text
        type="warning"
      />
    </div>

    <div
      v-if="!loading.cultures && grandesCulturesSorted.length > 0"
      class="primary--text mt-3 mb-1"
      :class="$vuetify.breakpoint.mobile ? 'titre-h4' :'titre-h2' "
    >
      <v-icon
        v-if="!$vuetify.breakpoint.mobile"
        color="primary"
        size="25"
      >
        mdi-seed-outline
      </v-icon>
      Grandes cultures ({{ grandesCulturesSorted.length }})
    </div>
    <div
      v-if="!loading.cultures && (hasUneDonneeManquante || hasUneDonneeNonVerifiee) && grandesCulturesSorted.length > 0"
      class="d-flex text-orange font-weight-bold ml-8"
    >
      <v-icon color="var(--orange-dark)">
        mdi-information
      </v-icon>
      <span class="align-self-center pl-2 pt-1">Complétez vos données afin d'accéder aux comparaisons de groupe.</span>
    </div>
    <v-row v-if="!loading.cultures && !serverError">
      <v-col
        v-for="(culture, index) in grandesCulturesSorted"
        :key="index"
        cols="12"
        md="3"
      >
        <v-card
          :class="!culture.isDonneesVerifiees || hasCultureDonneeManquante(culture) ? 'border-color-incomplete' : '' "
          class="eq-height pr-2"
        >
          <CultureRestitution
            :annee-selected="anneeSelected"
            :culture="culture"
            :recolte="recolte"
            :has-cloture-verrouillee="hasClotureVerrouillee"
            @edit="onEdit"
          />
        </v-card>
      </v-col>
      <v-col
        :md="cultures.length === 0 ? 12 : 3"
        cols="12"
      >
        <v-row
          v-if="!loading.cultures && cultures.length === 0"
          no-gutters
        >
          <BaseCardV2
            class="mt-5"
          >
            <div
              :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
              class="d-flex align-center flex-column pb-6"
            >
              <img
                alt="no-cultures"
                src="@/assets/no-cultures.svg"
              >
              <div
                :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
                class=" d-flex justify-center flex-column intro texte-gris-fonce text-align-center mt-2 text-justify mx-5"
              >
                <span class="text-center">Nous ne disposons pas de votre assolement pour cette année de récolte.</span>
                <span class="mt-1 mb-5 text-center">Ajoutez votre première culture pour bénéficier de l’outil d'analyse (anonymisé et globalisé).</span>
                <div class="d-flex justify-center">
                  <v-tooltip
                    v-if="!hasDroitEcriture || hasClotureVerrouillee"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <BaseButton
                          is-disabled
                          is-color-branche
                          libelle-btn="Ajouter une culture"
                        />
                      </div>
                    </template>
                    {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
                  </v-tooltip>
              
                  <div
                    v-else
                    class="d-flex justify-center"
                  >
                    <BaseButton
                      libelle-btn="Ajouter une culture"
                      is-color-branche
                      @click="onAjouteCulture"
                    />
                  </div>
                </div>
              </div>
            </div>
          </BaseCardV2>
        </v-row>
      </v-col>
    </v-row>
    <div
      v-if="!loading.cultures && grandesCulturesSorted.length > 0"
      class="d-flex justify-center"
    >
      <v-tooltip
        v-if="!hasDroitEcriture || hasClotureVerrouillee"
        bottom
      >
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <BaseButton
              is-disabled
              libelle-btn="Ajouter une culture"
            />
          </div>
        </template>
        {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
      </v-tooltip>
      <div
        v-else
        class="d-flex justify-center"
      >
        <BaseButton
          libelle-btn="Ajouter une culture"
          @click="onAjouteCulture"
        />
      </div>
    </div>
    <v-divider
      v-if="!loading.cultures && grandesCulturesSorted.length > 0 && autresProductionsVegetalesSorted.length > 0"
      class="mx-1 my-4"
    />
    <div
      v-if="!loading.cultures && autresProductionsVegetalesSorted.length > 0"
      class="primary--text mt-5 "
      :class="$vuetify.breakpoint.mobile ? 'titre-h4' :'titre-h2' "
    >
      <v-icon
        v-if="!$vuetify.breakpoint.mobile"
        color="primary"
        size="25"
      >
        mdi-seed-outline
      </v-icon>
      Autres productions végétales  ({{ autresProductionsVegetalesSorted.length }})
      <v-icon
        color="primary"
        size="26"
        @click="isOPenDetailAPV = !isOPenDetailAPV"
      >
        {{ isOPenDetailAPV ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </div>
    <v-row v-if="!loading.cultures && isOPenDetailAPV && autresProductionsVegetalesSorted.length> 0">
      <v-col
        v-for="(culture, index) in autresProductionsVegetalesSorted"
        :key="index"
        cols="12"
        md="3"
      >
        <v-card
          class="eq-height pr-2"
        >
          <CultureRestitution
            :annee-selected="anneeSelected"
            :culture="culture"
            :recolte="recolte"
            :has-cloture-verrouillee="hasClotureVerrouillee"
            is-apv
            @edit="onEdit"
          />
        </v-card>
      </v-col>
      <v-col
        :md="cultures.length === 0 ? 12 : 3"
        cols="12"
      >
        <v-row no-gutters>
          <BaseCardV2
            v-if="!loading.cultures && cultures.length === 0"
            class="mt-5"
          >
            <div
              :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
              class="d-flex align-center flex-column pb-6"
            >
              <img
                alt="no-cultures"
                src="@/assets/no-cultures.svg"
              >
              <div
                :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
                class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2 text-justify mx-5"
              >
                <span class="text-center">Nous ne disposons pas de votre assolement pour cette année de récolte.</span>
                <span class="mt-1 mb-5 text-center">Ajoutez votre première culture pour bénéficier de l’outil d'analyse (anonymisé et globalisé).</span>
                <v-tooltip
                  v-if="!hasDroitEcriture"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <BaseButton
                        libelle-btn="Ajouter une culture"
                      />
                    </div>
                  </template>
                  <span class="texte white--text">Vous n'avez pas les autorisations</span>
                </v-tooltip>
                <BaseButton
                  v-else
                  libelle-btn="Ajouter une culture"
                  @click="onAjouteCulture()"
                />
              </div>
            </div>
          </BaseCardV2>
        </v-row>
      </v-col>
    </v-row>
    <div
      v-if="!loading.cultures && isOPenDetailAPV && autresProductionsVegetalesSorted.length > 0"
      class="d-flex justify-center"
    >
      <v-tooltip
        v-if="!hasDroitEcriture || hasClotureVerrouillee"
        bottom
      >
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <BaseButton
              is-disabled
              libelle-btn="Ajouter une culture"
            />
          </div>
        </template>
        {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
      </v-tooltip>
      <div
        v-else
        class="d-flex justify-center"
      >
        <BaseButton
          libelle-btn="Ajouter une culture"
          @click="onAjouteCulture"
        />
      </div>
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="mes cultures"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Créez vos cultures ou retrouvez ici les surfaces transmises à votre conseiller environnement.</p>
          <p>Chaque culture affichée sera automatiquement alimentée par le poids de vos apports à Agrial (poids aux normes) : à vous de compléter cette donnée si besoin.</p>
          <p>Une fois votre rendement complété, vous pourrez le comparer avec votre groupe sur toutes les cultures regroupées dans "Grandes cultures".</p>
          <p>Si votre rendement est incohérent, il ne sera pas pris en compte dans la moyenne du groupe.</p>
        </div>
      </div>
    </HelpModal>
    <v-dialog
      v-model="isOpenModalAjoutCultures"
      fullscreen
      transition="slide-x-transition"
    >
      <AjoutCultureModal
        v-if="isOpenModalAjoutCultures"
        :annee="anneeSelected"
        :culture="cultureSelected"
        :cultures="cultures"
        :step-parent="$route.params.isModalCultureOpen ? 2 : 1"
        @close="onCloseAjoutCulture()"
      />
    </v-dialog>
  </div>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessage from '@/components/common/base-message.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import ResumeCultures from '@/views/cultures/components/resume-cultures.vue'
import CultureRestitution from './components/culture-restitution.vue'
import {AgrButton} from '@agrial/ui'
import {mapActions, mapGetters} from 'vuex'
import {orderBy, sum} from 'lodash'
import AjoutCultureModal from '@/views/cultures/components/modal/ajout-culture-modal.vue'
import AdherentRebond from '@/views/admin/rebond/components/adherent-rebond.vue'
import BaseButton from '@/components/common/base-button.vue'
import { hasClotureEnCoursModifiable } from '@/utils/cloture'

export default {
  name: 'MesCultures',
  components: {AdherentRebond, AgrButton, BaseButton, BaseCardV2, HelpModal, ResumeCultures, CultureRestitution, BaseLoader, BaseMessage, BaseMessageServerError, AjoutCultureModal },
  data () {
    return {
      pagePath: 'main.mes-cultures',
      loading:{
        cultures: false,
        filtres: false
      },
      erreur: {
        filtres: false
      },
      serverError: false,
      cultureSelected: null,
      anneeSelected: null,
      isOpenModalHelp: false,
      isOpenModalAjoutCultures: false,
      isOPenDetailAPV: false
    }
  },
  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent',
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive',
      recolte: 'recolte/recolte',
      cultures: 'culture/cultures',
      arborescenceTypeCulture: 'application/arborescenceTypeCulture',
      redirection: 'redirection/redirection',
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage'
    }),
    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage?.isAtelierVerrouille
    },
    hasClotureEnCours () {
      return hasClotureEnCoursModifiable(this.atelierCultureVerrouillage)
    },
    hasUneDonneeManquante () {
      return this.grandesCulturesSorted.some(culture => this.hasCultureDonneeManquante(culture))
    },
    hasUneDonneeNonVerifiee () {
      return this.grandesCulturesSorted.some(culture => this.hasCultureNonVerifiee(culture))
    },
    hasDroitEcriture () {
      return this.$roles.hasCulturesWriteAccess()
    },
    listeAnnees () {
      return [(Number(this.anneeRecolteEnCours) - 3).toString(),
        (Number(this.anneeRecolteEnCours) - 2).toString(),
        (Number(this.anneeRecolteEnCours) - 1).toString(),
        this.anneeRecolteEnCours,
        (Number(this.anneeRecolteEnCours) + 1).toString()
      ]
    },
    cumulPoidsNetEnKg () {
      let resumeParGraine = this.recolte.recoltesGraine.flatMap(r => r.resume)
      let poidsNetEnKg = resumeParGraine.flatMap(p => p.cumulPoidsNetEnKg)
      return sum(poidsNetEnKg)
    },
    resumeRecolte () {
      return {
        'sau': sum(this.cultures.flatMap(c => c.surfaceEnHectare)),
        'annee': this.anneeSelected,
        'nbCultures': this.cultures.length
      }
    },
    grandesCulturesSorted () {
      return orderBy(this.cultures.filter(c =>c.typeCulture.codeTypeCultureParent === 'GC'), ['surfaceEnHectare'], ['desc'])
    },
    autresProductionsVegetalesSorted () {
      return orderBy(this.cultures.filter(c =>c.typeCulture.codeTypeCultureParent === 'APV'), ['surfaceEnHectare'], ['desc'])
    }
  },

  watch: {
    isOpenModalAjoutCultures (newValue, oldValue) {
      if (!newValue && oldValue) {
        this.cultureSelected = null
      }
    }
  },

  created () {
    this.getRedirection(this.pagePath)
    this.loading.cultures = true
    this.fetchRecoltesContractualiseesEtRecoltees()
    this.anneeSelected = this.anneeRecolteActive != null ? this.anneeRecolteActive : this.anneeRecolteEnCours
    if (this.$cookies.get('NUMTIERS_SELECTED')) {
      this.fetchAdherent(this.$cookies.get('NUMTIERS_SELECTED'))
        .then(() => {
          this.loadFiltres()
          this.loadRecoltes()
        })
    } else {
      this.loadFiltres()
      this.loadRecoltes()
    }
    if (this.$route.params.isModalCultureOpen) {
      this.cultureSelected = this.cultures.find(c => c.typeCulture.code === this.codeGraineActive)
      this.isOpenModalAjoutCultures = true
    }
    if (this.grandesCulturesSorted.length === 0) {
      this.isOPenDetailAPV = true
    }
    this.updateCodeGraineActive(null)
  },

  methods: {
    ...mapActions({
      fetchAdherent: 'adherent/fetchAdherent',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      fetchRecoltesContractualiseesEtRecoltees: 'recolte/fetchRecoltesContractualiseesEtRecoltees',
      fetchRecolte: 'recolte/fetchRecolte',
      updateAnneeRecolteActive: 'application/updateAnneeRecolteActive',
      getCultures: 'culture/getCultures',
      getCulturesSansMouvement: 'culture/getCulturesSansMouvement',
      initFiltres: 'filtresComparaison/initFiltres',
      getRedirection: 'redirection/getRedirection',
      getAtelierCultureVerrouillage:'cloture/getAtelierCultureVerrouillage'
    }),
    loadRecoltes () {
      this.fetchRecolte()
        .then(() => {
          Promise.all([
            this.getCultures(this.anneeSelected),
            this.getCulturesSansMouvement(this.anneeSelected),
            this.getAtelierCultureVerrouillage()
          ])
            .catch(() => {
              this.serverError = true
            })
            .finally(() => {
              this.loading.cultures = false
            })
        })
        .catch(() => {
          this.serverError = true
        })

    },
    loadFiltres () {
      this.loading.filtres = true
      this.erreur.filtres = false

      return this.initFiltres(this.adherent.codeRegion)
        .catch(() => {
          this.erreur.filtres = true
        })
        .finally(() => {
          this.loading.filtres = false
        })
    },
    selectRecolte (value) {
      this.loading.cultures = true
      this.anneeSelected = value
      this.updateAnneeRecolteActive(value)
        .then(() => {
          this.loadRecoltes()
        })
        .catch(() => {
          this.serverError = true
        })
    },
    hasCultureDonneeManquante (culture) {
      return !culture.rendementEnQuintauxParHectare || culture.rendementEnQuintauxParHectare === 0 ||
        !culture.surfaceEnHectare || culture.surfaceEnHectare === 0 ||
        !culture.poidsEnTonne || culture.poidsEnTonne === 0 ||
        (['LFH', 'LFP'].includes(culture.typeCulture.code) && (!culture.tauxFilasseEnPourcentage || culture.tauxFilasseEnPourcentage === 0))
    },
    hasCultureNonVerifiee (culture) {
      return !culture.isDonneesVerifiees
    },
    onAjouteCulture () {
      this.isOpenModalAjoutCultures = true
    },
    onCloseAjoutCulture () {
      this.isOpenModalAjoutCultures = false
      this.cultureSelected = null
    },
    onEdit (culture) {
      this.cultureSelected = culture
      this.isOpenModalAjoutCultures = true
    },
  }
}
</script>

<style lang="scss" scoped>
.align-end {
  text-align: end;
}
.align-center {
  text-align: center;
}
.display-flex {
  display: flex;
}
.border-color-incomplete {
  border: 2px solid var(--orange-dark);
}
.text-orange {
  color: var(--orange-dark);
}
.position {
  position: absolute;
  top: 0;
  right: 8px;
}
</style>
